export default "__VITE_ASSET__Ba19Z7As__"